import * as checkoutAPI from "tsi-common-react/src/api/checkout";
import { registerCommonCascades } from "tsi-common-react/src/apps/checkout/cascades-main";
import { defaults } from "tsi-common-react/src/apps/checkout/defaults";
import { setFields } from "tsi-common-react/src/apps/checkout/reducers";
import {
    loadBasket,
    loadShippingAndBillingAddresses,
} from "tsi-common-react/src/apps/checkout/thunks";
import {
    openApplyModal,
    openPreQualModal,
} from "tsi-common-react/src/apps/financing/reducers";
import * as signals from "tsi-common-react/src/store/signals";
import { onReadyStateComplete } from "tsi-common-react/src/utils/events";
import { strToBool } from "tsi-common-react/src/utils/format";
import { navigateToHome } from "tsi-common-react/src/utils/urls";

import { getDocument, getWindow } from "@thelabnyc/thelabui/src/utils/dom";

import { persistor, rehydratingStore, store } from "../../store";

// ============================================================================
// Render checkout app components
// ============================================================================
const componentsRendering = rehydratingStore.then(() => {
    // Register store cascades
    registerCommonCascades(store);

    // The basket and checkout apps are rendered inside the React document
    // (BasketDocumentTemplate -> BasketApp, CheckoutDocumentTemplate ->
    // CheckoutApp) and mounted client-side within the document tree; they load
    // their data via the cascades registered here. Checkout-specific cascades
    // are registered in CheckoutAppInner when the checkout app loads.
});

// ============================================================================
// Special On-Page-Load Functionality
// ============================================================================
const wipeCheckoutData = () => {
    console.debug("Erasing transient checkout data...");
    persistor.purge();
    checkoutAPI.clearShippingAddress();
    checkoutAPI.clearBillingAddress();
    store.dispatch(setFields(defaults.form));
};

onReadyStateComplete.on(async () => {
    const window = getWindow();
    const document = getDocument();
    if (!window || !document) {
        return;
    }
    const url = new URL(window.location.href);

    // Wait for redux store to finish loading
    await rehydratingStore;
    await componentsRendering;

    // Redirect from basket page to homepage after 60 min delay
    const basketApp = document.getElementById("basket-app");
    if (basketApp) {
        setTimeout(() => {
            navigateToHome();
        }, 3600_000);
    }

    // Auto open PreQual modal?
    const openPreQualModel = strToBool(
        `${url.searchParams.get("resume-prequal") || "no"}`,
    );
    if (openPreQualModel) {
        store.dispatch(openPreQualModal({}));
    }

    // Auto open Financing Application modal?
    const openCreditAppModel = strToBool(
        `${url.searchParams.get("open-credit-app") || "no"}`,
    );
    if (openCreditAppModel) {
        const appSource = `${url.searchParams.get("credit-app-source")}`;
        // TODO(i18n): Wrap default user-facing string in t tagged template: t`Financing Page`
        store.dispatch(
            openApplyModal({
                applicationSource: appSource || "Financing Page",
            }),
        );
    }

    // Wipe checkout data?
    if (document.body.classList.contains("js-wipe-checkout-data")) {
        wipeCheckoutData();
    }
});

// ============================================================================
// CSR Toolbar Integration
// ============================================================================
const reloadCheckoutData = () => {
    wipeCheckoutData();
    console.log("Reloading basket data");
    store.dispatch(loadBasket());
    console.log("Reloading shipping and billing address");
    store.dispatch(loadShippingAndBillingAddresses());
};

signals.csr.onBeforeStartNewBasket.on(wipeCheckoutData);
signals.csr.onAfterStartAssistingCustomer.on(reloadCheckoutData);
signals.csr.onAfterStopAssistingCustomer.on(reloadCheckoutData);
